import { TTask } from 'types/task';
import { z } from 'zod';

export type TClientTask = Omit<TTask, 'picture' | 'pictures'> & {
    picture: TTask['picture'] | File;
    pictures: TTask['picture'][] | File[];
};

export const TaskSchema = z.object({
    id: z.number().optional().default(-1),

    name: z.string().min(1, 'Имя задачи не может быть пустым').default(''),

    task_statement: z
        .array(
            z.object({
                id: z.number().optional(),
                name: z.string(),
                url: z.string().url().optional(),
                size: z.number().optional(),
                type: z.string().optional(),
            })
        )
        .nullable()
        .optional()
        .default(null),

    description: z.string().nullable().optional().default(null),
    description_type: z.enum(['text', 'voice']).optional().default('text'),

    duration: z
        .number()
        .min(0, 'Продолжительность должна быть задана')
        .max(518_400, 'Продолжительность должна быть меньше 12 месяцев')
        .default(0),

    total_time: z.boolean().optional().default(false),

    reward: z
        .number()
        .min(0, 'На баланс исполнителя от 0 до 999 999.99 руб')
        .max(999_999.99, 'На баланс исполнителя от 0.01 до 999 999.99 руб')
        .optional()
        .default(0),

    task_category_id: z.number().nullable().default(null),

    products: z.array(z.any()).optional().default([]),
    services: z.array(z.any()).optional().default([]),

    min_performers: z
        .number('Количество исполнителей должно быть задано')
        .min(1, 'Количество исполнителей должно быть от 1 до 10')
        .max(10, 'Количество исполнителей должно быть от 1 до 10')
        .default(1),

    price: z
        .number()
        .min(0, 'Цена должна быть >= 0')
        .max(9_999_999.99, 'Цена должна быть <= 9 999 999.99')
        .optional()
        .default(0),

    quantity: z.number().min(0).max(99_999).optional().default(0),

    is_other: z.union([z.boolean(), z.number().int()]).optional(),

    activity_category_id: z.number().optional(),
    base_task_id: z.number().nullable().optional(),
});
